'use client'

import { sendClientRequest } from '@/utils/client-request'

type Ctx = { vendorId: string; session?: any }

const headers = ({ vendorId }: Ctx) => ({ Vendor: vendorId }) as any

export const getLoyaltyTiersApi = (ctx: Ctx) =>
  sendClientRequest({ url: '/loyalty/tiers', auth: false, headers: headers(ctx) })

export const getLoyaltySummaryApi = (ctx: Ctx) =>
  sendClientRequest({ url: '/loyalty/me', session: ctx.session, headers: headers(ctx) })

export const getLoyaltyTransactionsApi = (ctx: Ctx, page = 1, limit = 20) =>
  sendClientRequest({ url: `/loyalty/me/transactions?page=${page}&limit=${limit}`, session: ctx.session, headers: headers(ctx) })

export const getLoyaltyVouchersApi = (ctx: Ctx) =>
  sendClientRequest({ url: '/loyalty/me/vouchers', session: ctx.session, headers: headers(ctx) })

export const convertPointsApi = (ctx: Ctx, points: number) =>
  sendClientRequest({ url: '/loyalty/voucher', method: 'POST', body: { points }, session: ctx.session, headers: headers(ctx) })
